import styled from "styled-components"
import { useTranslation } from "next-i18next"
import { serverSideTranslations } from "next-i18next/serverSideTranslations"
import MetaData from "@/common/components/MetaData"
import Sticky from "react-stickynode"
import dynamic from "next/dynamic"
import { UseCase, UseCaseLayout } from "@/common/components/UseCase"

import YGGJLOGO from "@/common/assets/image/walletAsAService/showCase/YGGJLOGO.webp"
import YGGJHero from "@/common/assets/image/walletAsAService/showCase/hero&banner/YGGJ Hero.webp"
import YGGJ1_P from "@/common/assets/image/walletAsAService/showCase/premise/YGGJ1.svg"
import YGGJ2_P from "@/common/assets/image/walletAsAService/showCase/premise/YGGJ2.svg"
import YGGJ3_P from "@/common/assets/image/walletAsAService/showCase/premise/YGGJ3.svg"
import YGGJ1_S from "@/common/assets/image/walletAsAService/showCase/solutions/YGGJ1.webp"
import YGGJ2_S from "@/common/assets/image/walletAsAService/showCase/solutions/YGGJ2.webp"
import YGGJ3_S from "@/common/assets/image/walletAsAService/showCase/solutions/YGGJ3.webp"
import lineGroupB from "@/common/assets/image/walletAsAService/showCase/premise/lineGroupB.svg"

const NavbarNew = dynamic(import("@/containers/common/NavbarNew"))
const StickeyUseCasePage = () => {
  const { t } = useTranslation(["useCaseStickey"])
  return (
    <>
      <MetaData
        title={t("meta.title")}
        description={t("meta.description")}
        url={t("meta.url")}
        image="https://storage.googleapis.com/kryptogo-official-website-public/og-logo.webp"
        languageAlternates={[
          {
            hrefLang: "en-US",
            href: "https://www.kryptogo.com/use-case/stickey-wallet"
          },
          {
            hrefLang: "zh-TW",
            href: "https://www.kryptogo.com/tw/use-case/stickey-wallet"
          },
          {
            hrefLang: "zh-CN",
            href: "https://www.kryptogo.com/cn/use-case/stickey-wallet"
          },
          {
            hrefLang: "ja-JP",
            href: "https://www.kryptogo.com/ja/use-case/stickey-wallet"
          }
        ]}
      />
      <Sticky top={0} innerZ={1000} activeClass="sticky-active">
        <NavbarNew />
      </Sticky>
      <LayoutWrapper>
        <UseCaseLayout
          content={
            <UseCase
              data={{
                hero: {
                  title1: t("hero.title1"),
                  title2: t("hero.title2"),
                  title3: t("hero.title3"),
                  desc: t("hero.desc"),
                  icon: YGGJLOGO,
                  btns: "",
                  hero: YGGJHero
                },
                showCaseCounter: [
                  {
                    content: t("counter.1.content"),
                    desc: t("counter.1.desc")
                  },
                  {
                    content: t("counter.2.content"),
                    desc: t("counter.2.desc")
                  },
                  {
                    content: t("counter.3.content"),
                    desc: t("counter.3.desc")
                  }
                ],
                theySays: {
                  content1: t("theySays.content1"),
                  content2: t("theySays.content2")
                },
                premise: {
                  title2: t("premise.title2"),
                  content1: [
                    t("premise.content1.1"),
                    t("premise.content1.2"),
                    t("premise.content1.3")
                  ],
                  content2: [
                    { Icon: YGGJ1_P, content: t("premise.content2.1") },
                    { Icon: YGGJ2_P, content: t("premise.content2.2") },
                    { Icon: YGGJ3_P, content: t("premise.content2.3") }
                  ],
                  result: t("premise.result"),
                  lineGroup: lineGroupB
                },
                solution: {
                  title: t("solution.title"),
                  QA: [
                    {
                      q: t("solution.1.q"),
                      a: t("solution.1.a"),
                      img: YGGJ1_S
                    },
                    {
                      a: t("solution.2.a"),
                      q: t("solution.2.q"),
                      img: YGGJ2_S
                    },
                    {
                      q: t("solution.3.q"),
                      a: t("solution.3.a"),
                      img: YGGJ3_S
                    }
                  ]
                },

                color: {
                  primary: "#00D5FF",
                  secondary: "#1973F6"
                }
              }}
              next="tag-wallet"
            />
          }
        />
      </LayoutWrapper>
    </>
  )
}

export const getStaticProps = async ({ locale }: { locale: string }) => ({
  props: {
    ...(await serverSideTranslations(locale, [
      "common",
      "contactUs",
      "useCaseCommon",
      "useCaseStickey"
    ]))
  }
})

export default StickeyUseCasePage

const LayoutWrapper = styled.div`
  width: 100%;
  overflow: hidden;
  display: grid;
  grid-template-columns: 1fr;
`
